// src/components/Activities/HostCountryProfile.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Activities.css';
// Import the background image from assets
import summitBg from '../../assets/images/summit.jpeg';

const HostCountryProfile = () => {
    const [activeSection, setActiveSection] = useState(null);

    const toggleSection = (id) => {
        setActiveSection(activeSection === id ? null : id);
    };

    const sections = [
        {
            id: 1,
            icon: '🌍',
            title: 'Strategic Location & Gateway to Africa',
            description: 'Nigeria is Africa\'s most populous nation and largest economy, serving as the continent\'s gateway to global trade and investment. With its strategic location in West Africa, Nigeria offers unparalleled access to the ECOWAS market of over 350 million people, making it an ideal hub for businesses seeking to expand across the continent.'
        },
        {
            id: 2,
            icon: '💰',
            title: 'Rich Natural Resources & Energy Hub',
            description: 'Nigeria is endowed with abundant natural resources including oil, gas, solid minerals, and vast agricultural land. As Africa\'s largest oil producer and holder of the continent\'s largest natural gas reserves, Nigeria is a global energy powerhouse actively transitioning towards renewable energy and sustainable resource management.'
        },
        {
            id: 3,
            icon: '🏗️',
            title: 'Infrastructure Development Boom',
            description: 'Nigeria is experiencing a massive infrastructure transformation with major projects in transportation, power, housing, and digital infrastructure. The government\'s infrastructure investment plan includes railway modernization, road construction, port expansion, and the development of smart cities, creating significant opportunities for investors.'
        },
        {
            id: 4,
            icon: '👥',
            title: 'Large & Young Workforce',
            description: 'With a population of over 200 million, Nigeria has the largest youth population in Africa. This demographic dividend offers a dynamic and growing workforce, a vibrant consumer market, and a thriving tech ecosystem. Nigeria\'s young entrepreneurs are driving innovation in fintech, agritech, and digital services.'
        },
        {
            id: 5,
            icon: '📈',
            title: 'Fastest Growing Economy in Africa',
            description: 'Nigeria is projected to be among the fastest-growing economies in Africa, driven by diversification into non-oil sectors, including agriculture, manufacturing, telecommunications, and services. The government\'s economic diversification strategy aims to reduce oil dependence and create sustainable growth across multiple sectors.'
        },
        {
            id: 6,
            icon: '🌿',
            title: 'Climate Action & Green Investment Leadership',
            description: 'Nigeria is at the forefront of Africa\'s climate action, committed to achieving Net Zero emissions by 2060. The country is investing heavily in renewable energy, afforestation, climate resilience, and sustainable infrastructure. Nigeria\'s green investment opportunities include solar energy, electric vehicles, and climate-smart agriculture.'
        }
    ];

    return (
        <div className="activity-page">
            {/* Hero Section - Using summit.jpg from assets */}
            <div
                className="activity-hero host-country-hero"
                style={{
                    backgroundImage: `url(${summitBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed'
                }}
            >
                <div className="host-country-hero-overlay"></div>
                <div className="host-country-hero-content">
                    <span className="activity-hero-badge">HOST COUNTRY</span>
                    <h1>Nigeria</h1>
                    <p>Africa's Giant - A Land of Opportunity</p>
                </div>
            </div>

            {/* President Section */}
            <div className="president-section">
                <div className="president-container">
                    <div className="president-image-wrapper">
                        <img
                            src="/images/president-tinubu.jpg"
                            alt="President Bola Ahmed Tinubu"
                            className="president-image"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = '<div class="president-placeholder">👤</div>';
                            }}
                        />
                    </div>
                    <div className="president-info">
                        <h2>His Excellency</h2>
                        <h1>Bola Ahmed Tinubu, GCFR</h1>
                        <p>President and Commander-in-Chief of the Armed Forces</p>
                        <p className="president-country">Federal Republic of Nigeria</p>
                        <div className="president-divider"></div>
                        {/* <p className="president-message">
                            "Nigeria is open for business and investment. We are committed to creating
                            an enabling environment for sustainable development, infrastructure growth,
                            and climate action that benefits all Africans."
                        </p> */}
                    </div>
                </div>
            </div>

            {/* Nigeria Highlights */}
            <div className="nigeria-highlights">
                <div className="highlights-header">
                    <span className="highlights-badge">DISCOVER NIGERIA</span>
                    <h2>Why Nigeria?</h2>
                    <p>Click on each category to learn more about Nigeria's opportunities</p>
                    <div className="highlights-line"></div>
                </div>

                <div className="highlights-grid">
                    {sections.map((section) => (
                        <div className={`highlight-card ${activeSection === section.id ? 'active' : ''}`} key={section.id}>
                            <div className="highlight-card-header" onClick={() => toggleSection(section.id)}>
                                <span className="highlight-icon">{section.icon}</span>
                                <h3>{section.title}</h3>
                                <span className="highlight-toggle">{activeSection === section.id ? '−' : '+'}</span>
                            </div>
                            {activeSection === section.id && (
                                <div className="highlight-card-content">
                                    <p>{section.description}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Back Button */}
            <div className="activity-back" style={{ paddingBottom: '60px' }}>
                <Link to="/activities" className="back-button">← Back to Activities</Link>
            </div>
        </div>
    );
};

export default HostCountryProfile;